import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "w-lg-500px bg-white rounded shadow-sm px-10 pb-10 px-lg-15 pb-lg-15 mx-auto" }
const _hoisted_2 = { class: "fv-row mb-10" }
const _hoisted_3 = { class: "fv-plugins-message-container" }
const _hoisted_4 = { class: "fv-help-block" }
const _hoisted_5 = { class: "fv-row mb-10" }
const _hoisted_6 = { class: "fv-plugins-message-container" }
const _hoisted_7 = { class: "fv-help-block" }
const _hoisted_8 = { class: "text-center" }
const _hoisted_9 = {
  type: "submit",
  ref: "submitButton",
  id: "kt_sign_in_submit",
  class: "btn btn-lg btn-primary w-100 mb-5"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_Form = _resolveComponent("Form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_Form, {
      class: "form w-100",
      id: "kt_login_signin_form",
      onSubmit: _ctx.onSubmitLogin,
      "validation-schema": _ctx.login
    }, {
      default: _withCtx(() => [
        _cache[4] || (_cache[4] = _createElementVNode("div", { class: "cdr-ribbon" }, null, -1)),
        _cache[5] || (_cache[5] = _createElementVNode("div", { class: "login-container" }, [
          _createElementVNode("a", { href: "#" }, [
            _createElementVNode("img", {
              alt: "Logo",
              src: "/media/logos/logoCDR.svg",
              class: "cdr-logo mb-12"
            })
          ]),
          _createElementVNode("div", { class: "login-header" }, [
            _createElementVNode("h3", { class: "text-primary text-uppercase fw-boldest fs-1" }, "Members"),
            _createElementVNode("h3", { class: "text-primary text-uppercase fw-lighter fs-1" }, "Administration")
          ])
        ], -1)),
        _cache[6] || (_cache[6] = _createElementVNode("div", { class: "mb-5" }, [
          _createElementVNode("h1", { class: "text-primary mt-15 fw-boldest" }, "Sign in")
        ], -1)),
        _createElementVNode("div", _hoisted_2, [
          _cache[1] || (_cache[1] = _createElementVNode("label", { class: "form-label fs-4 text-muted" }, "Email Address", -1)),
          _createVNode(_component_Field, {
            class: "form-control form-control-lg form-control-solid",
            type: "text",
            name: "email",
            autocomplete: "off"
          }),
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createVNode(_component_ErrorMessage, { name: "email" })
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_5, [
          _cache[2] || (_cache[2] = _createElementVNode("div", { class: "d-flex flex-stack mb-2" }, [
            _createElementVNode("label", { class: "form-label text-muted fs-4 mb-0" }, "Password")
          ], -1)),
          _createVNode(_component_Field, {
            class: "form-control form-control-lg form-control-solid mb-2",
            type: "password",
            name: "password",
            autocomplete: "off"
          }),
          _createElementVNode("p", {
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.redirectChangePassword())),
            role: "button",
            class: "text-muted fs-6 m-0"
          }, "Forgot Password ?"),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createVNode(_component_ErrorMessage, { name: "password" })
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("button", _hoisted_9, [...(_cache[3] || (_cache[3] = [
            _createElementVNode("span", { class: "indicator-label" }, " Sign In ", -1),
            _createElementVNode("span", { class: "indicator-progress" }, [
              _createTextVNode(" Please wait... "),
              _createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" })
            ], -1)
          ]))], 512)
        ])
      ]),
      _: 1
    }, 8, ["onSubmit", "validation-schema"])
  ]))
}